export const EAGLEEYE_ADDRESS = '0x4e6a510659d3d0F6897bbab3Db67DA0B3d001fB7';
export const NODE_URL = "https://bsc-dataseed.binance.org/";
export const PROMO_TOKEN_TELEGRAM = "https://t.me/RugSeekers";
export const PROMOTIONAL_TOKEN_NAME = "RUGSEEKERS";
export const stopPropagation = (e: any) => {e.stopPropagation()}
